document.querySelectorAll('[data-foot-compare]').forEach(compare=>{
  const range=compare.querySelector('[data-compare-range]');
  const update=()=>{
    compare.style.setProperty('--compare-position',`${range.value}%`);
    range.setAttribute('aria-valuetext',`${range.value} percent of foot-shaped footwear shown`);
  };
  range.addEventListener('input',update);
  update();
});

document.querySelectorAll('[data-why-tabs]').forEach(tabs=>{
  const buttons=[...tabs.querySelectorAll('[data-why-tab]')];
  const panels=[...tabs.querySelectorAll('[data-why-panel]')];
  const activate=(button,focus=false)=>{
    buttons.forEach(item=>{
      const selected=item===button;
      item.setAttribute('aria-selected',String(selected));
      item.tabIndex=selected?0:-1;
    });
    panels.forEach(panel=>{panel.hidden=panel.dataset.whyPanel!==button.dataset.whyTab;});
    if(focus)button.focus();
  };
  buttons.forEach((button,index)=>{
    button.addEventListener('click',()=>activate(button));
    button.addEventListener('keydown',event=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();
      const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
      activate(buttons[next],true);
    });
  });
});

document.querySelectorAll('[data-why-carousel]').forEach(carousel=>{
  const slides=[...carousel.querySelectorAll('[data-why-slide]')];
  const dots=[...carousel.querySelectorAll('[data-why-dot]')];
  let current=0;
  const show=index=>{
    current=(index+slides.length)%slides.length;
    slides.forEach((slide,slideIndex)=>{slide.hidden=slideIndex!==current;});
    dots.forEach((dot,dotIndex)=>dot.setAttribute('aria-pressed',String(dotIndex===current)));
  };
  carousel.querySelector('[data-why-previous]')?.addEventListener('click',()=>show(current-1));
  carousel.querySelector('[data-why-next]')?.addEventListener('click',()=>show(current+1));
  dots.forEach(dot=>dot.addEventListener('click',()=>show(Number(dot.dataset.whyDot))));
});
